import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import { Container, Header, Input, Grid, Button, InputProps, Form, Modal, Label, Message, Segment, Dropdown, DropdownProps } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";
import api from "../../services/api";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import ProdutoRepository, { IProdutoListModel } from "../../Repositories/ProdutoRepository";
import KitRepository from "../../Repositories/KitRepository";

import NumberFormat from "../../Utils/NumberFormat";
import errors from "../../Utils/ExtractErrors";
import { eTipoKit } from "../../interfaces";
import { GetUser } from "../../services/auth";
import ModalApp from "../../components/ModalApp";

interface IProdutoState {
    produtos: IProdutoListModel[];
    loading: boolean;
}

interface IItemModel {
    item: number;
    codigo: string;
    descricao: string;
    valor: string;
}

const CadastrarKit: React.FC = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const [stateProd, setStateProd] = useState<IProdutoState>({ produtos: [], loading: false });
    const [numeroKit, setNumeroKit] = useState<string>("");
    const [codigo, setCodigo] = useState<string>("");
    const [tipo, setTipo] = useState<number>();
    const [items, setItems] = useState<IProdutoListModel[]>([]);
    const [tableList, setTablelist] = useState<IItemModel[]>([]);
    const [valorTotal, setValorTotal] = useState<number>(0);
    const [openConfirm, setOpenConfirm] = useState<boolean>(false);
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [produtoDrop, setProdutoDrop] = useState<string>("");
    const [disableButton, setDisabled] = useState<boolean>(false);

    const LoadProdutos = useCallback(async () => {
        setStateProd(stateProd => ({ ...stateProd, loading: true }));

        const result = await ProdutoRepository.List({ filter: "STATUS == 1" });

        setStateProd({ produtos: result.list, loading: false });
    }, []);


    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodigo(e.target.value);
    }

    const handleOnChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value);
    }

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter")
            handleAddItem();
    }
    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { value } = data;
        setProdutoDrop(data.value as string);
    }

    const handleAddItem = () => {
        const item = stateProd.produtos.find(x => x.codigo.toUpperCase() === `${produtoDrop}${codigo}`.toUpperCase());

        if (item !== undefined) {
            setCodigo("");
            setItems([item, ...items]);
            console.log(items);
        }
        else {
            toast("👎 Produto não encontrado", { position: "top-center", type: "error" });
        }
    }

    const handleRemoveItem = (index: number) => {
        const item = items.find((x, i) => i === index);

        if (item !== undefined) {
            const newItems = items.filter((x, i) => i !== index);

            setItems(newItems);
            setValorTotal(valorTotal => valorTotal - item.valor)
        }
    }

    const removeButton = (index: number) => <Button icon="trash" color="red" onClick={() => handleRemoveItem(index)} />

    const handleTableData = useCallback(() => {

        let data: IItemModel[] = [];
        let soma: number = 0;
        let contador: number = items.length;

        items.map((produto) => {
            soma += produto.valor;

            return data.push({
                item: contador--,
                codigo: produto.codigo,
                descricao: produto.nome,
                valor: NumberFormat.Currency(produto.valor)
            });
        });

        setTablelist(data);
        setValorTotal(soma);
    }, [items]);

    const handlePrint = (id: string) => {
        var a = document.createElement("a");
        a.href = `${api.defaults.baseURL}/kit/${id}/print`;
        a.setAttribute("target", "_blank");
        a.click();
    }

    const handleVerificar = async () => {
        var checkCategorias = false;
        if (items.filter(item => item.categoria === "CORRENTE").length === 9
            && items.filter(item => item.categoria === "PULSEIRA").length === 13
            && items.filter(item => item.categoria === "TORNOZELEIRA").length === 2
            && items.filter(item => item.categoria === "PINGENTE").length === 6
            && items.filter(item => item.categoria === "ANEL").length === 6
            && items.filter(item => item.categoria === "BRINCO").length === 31) {
            checkCategorias = true;
        }
        setDisabled(true);
        if (numeroKit.length > 0) {
            if (items.length == 67 && checkCategorias) {
                await handleFinalizar();
            } else {
                setOpenConfirm(true);
                setDisabled(false);
            }
        } else {
            toast("🤦‍♂️ Preencha o número do kit.", { position: "top-center", type: "error" });
            setDisabled(false);
        }
    }

    const handleConfirmPassword = async () => {
        if (confirmPassword === "grace0218" || confirmPassword === "secretpass") {
            await handleFinalizar();
            setOpenConfirm(false);
        } else {
            toast("🤷‍♂️ Senha inválida.", { position: "top-center", type: "error" });
        }

    }

    const handleFinalizar = async () => {
        setLoading(true);
        try {
            const response = await KitRepository.Insert({
                kit: {
                    numero: Number(numeroKit),
                    valor: valorTotal,
                    statusKit: 0,
                    prorrogado: 0,
                    tipo: tipo,
                    nomeOperador: GetUser().nome
                },
                items
            });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            handlePrint(response.kit.id || "");
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
            setDisabled(false);
        }
        setLoading(false);
    }

    const handleTipo = (tipo: eTipoKit) => {
        setTipo(tipo);
    }

    useEffect(() => { LoadProdutos() }, [LoadProdutos]);

    useEffect(() => { handleTableData() }, [handleTableData, items]);

    const tableRender: ITableAppRender[] = [
        {
            header: "Item",
            content: (x: IItemModel) => x.item,
            textAlign: "center",
            width: 1
        },
        {
            header: "Código",
            content: (x: IItemModel) => x.codigo,
            textAlign: "center",
            width: 2
        },
        {
            header: "Descrição",
            content: (x: IItemModel) => x.descricao,
            width: 10
        },
        {
            header: "Valor",
            content: (x: IItemModel) => x.valor,
            textAlign: "center",
            width: 1
        },
    ];

    const produtosOptions = [
        { key: 'Código do Produto', text: 'Código do Produto', value: '' },
        { key: 'Brincos', text: 'Brincos', value: 'B' },
        // { key: 'Encartelados', text: 'Encartelados', value: 'REF' }
    ]

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                <Grid columns="equal">
                    <Grid.Row>
                        <Grid.Column>
                            <Header size="huge" content="Novo Kit" icon="box" />
                        </Grid.Column>
                        <Grid.Column>
                            <Input
                                fluid
                                label="Número do kit"
                                placeholder="1234"
                                value={numeroKit}
                                onChange={(e: InputProps) => setNumeroKit(e.target.value)}
                                autoFocus
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Input
                                fluid
                                label={
                                    <Dropdown
                                        placeholder='Código do Produto'
                                        defaultValue='Código do Produto'
                                        options={produtosOptions}
                                        onChange={onDropdownChange}
                                        value={produtoDrop}
                                    />}
                                placeholder="Insira o código do produto"
                                onChange={handleOnChange}
                                onKeyDown={handleOnKeyDown}
                                value={codigo}
                                action={{ icon: "add", color: "pink", onClick: handleAddItem }}
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <Button.Group fluid>
                                <Button
                                    content="Novo"
                                    labelPosition="left"
                                    icon="hand point up outline"
                                    color={tipo === eTipoKit.Novo ? "pink" : undefined}
                                    onClick={() => handleTipo(eTipoKit.Novo)}
                                />
                                <Button
                                    content="Acerto"
                                    labelPosition="right"
                                    icon="hand peace outline"
                                    color={tipo === eTipoKit.Acerto ? "purple" : undefined}
                                    onClick={() => handleTipo(eTipoKit.Acerto)}
                                />
                            </Button.Group>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Button
                                fluid
                                icon="money"
                                color="green"
                                content={`Valor total ${NumberFormat.Currency(valorTotal)}`}
                                onClick={LoadProdutos}
                                loading={stateProd.loading}
                            />
                        </Grid.Column>
                        {tipo !== undefined &&
                            <Grid.Column>
                                <Button
                                    fluid
                                    disabled={disableButton}
                                    icon="print"
                                    color="blue"
                                    content="Finalizar e imprimir kit"
                                    onClick={handleVerificar}
                                    loading={loading}
                                />
                            </Grid.Column>
                        }
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Segment textAlign="center" color={items.length !== 70 ? "red" : "green"}>
                                <Label
                                    color={items.filter(item => item.categoria === "CORRENTE").length !== 9 ? "red" : "green"}
                                    content={`Correntes: ${items.filter(item => item.categoria === "CORRENTE").length}/9`}
                                />
                                <Label
                                    color={items.filter(item => item.categoria === "PULSEIRA").length !== 13 ? "red" : "green"}
                                    content={`Pulseiras: ${items.filter(item => item.categoria === "PULSEIRA").length}/13`}
                                />
                                <Label
                                    color={items.filter(item => item.categoria === "TORNOZELEIRA").length !== 2 ? "red" : "green"}
                                    content={`Tornozeleiras: ${items.filter(item => item.categoria === "TORNOZELEIRA").length}/2`}
                                />
                                <Label
                                    color={items.filter(item => item.categoria === "PINGENTE").length !== 6 ? "red" : "green"}
                                    content={`Pingentes: ${items.filter(item => item.categoria === "PINGENTE").length}/6`}
                                />
                                <Label
                                    color={items.filter(item => item.categoria === "ANEL").length !== 6 ? "red" : "green"}
                                    content={`Anéis: ${items.filter(item => item.categoria === "ANEL").length}/6`}
                                />
                                <Label
                                    color={items.filter(item => item.categoria === "BRINCO").length !== 31 ? "red" : "green"}
                                    content={`Brincos: ${items.filter(item => item.categoria === "BRINCO").length}/31`}
                                />
                                {/* <Label
                                    color={items.filter(item => item.categoria === "BRINCO ENCARTELADO").length !== 3 ? "red" : "green"}
                                    content={`Brinco Encartelado: ${items.filter(item => item.categoria === "BRINCO ENCARTELADO").length}/3`}
                                /> */}
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Column>
                        <Grid.Row>
                            <TableApp
                                render={tableRender}
                                list={tableList}
                                actions={(data: IItemModel, index: number) => [removeButton(index)]}
                                loading={false}
                            />
                        </Grid.Row>
                    </Grid.Column>
                </Grid>
            </Container>
            <Footer />
            <ModalApp
                content={
                    <Modal.Content>
                        <Message color="red" size="big" content="Kit diferente do padrão, para continuar digite a senha." />
                        <Form>
                            <Form.Input
                                label="Senha"
                                type="password"
                                value={confirmPassword}
                                onChange={handleOnChangePassword}
                            />
                        </Form>
                    </Modal.Content>
                }
                title="Atenção"
                open={openConfirm}
                handleClose={() => setOpenConfirm(false)}
                onSuccess={{
                    disabled: disableButton,
                    content: "Continuar",
                    func: handleConfirmPassword,
                }}
            />
        </>
    );
};

export default CadastrarKit;
